import React from 'react';
import { IPotentialMatch } from './IPotentialMatch';
import { ExpectedDisplay } from './ExpectedDisplay';
import { ExpectedOrderDisplay } from './ExpectedOrderDisplay';
import { HeaderBar } from './HeaderBar';

export interface IPotentialDisplay {
  potentialMatch: IPotentialMatch;
  accountNumber: string;
  onMatch?: () => void;
}

export const PotentialDisplay: React.FC<IPotentialDisplay> = ({ potentialMatch, accountNumber, onMatch }) => {
  return (
    <>
      {potentialMatch.expectedACH && (
        <>
          <div className={'text-lg font-semibold text-left'}>This is the ACH information you selected</div>
          <HeaderBar />
          <ExpectedDisplay
            expected={potentialMatch.expectedACH}
            accountNumber={accountNumber}
            actionLabel={'Confirm Match'}
            onAction={onMatch}
          />
        </>
      )}
      {potentialMatch.expectedCheck && (
        <>
          <div className={'text-lg font-semibold text-left'}>This is the check information you selected</div>
          <HeaderBar />
          <ExpectedDisplay
            expected={potentialMatch.expectedCheck}
            accountNumber={accountNumber}
            actionLabel={'Confirm Match'}
            onAction={onMatch}
          />
        </>
      )}
      {potentialMatch.expectedWire && (
        <>
          <div className={'text-lg font-semibold text-left'}>This is the wire information you selected</div>
          <HeaderBar />
          <ExpectedDisplay
            expected={potentialMatch.expectedWire}
            accountNumber={accountNumber}
            actionLabel={'Confirm Match'}
            onAction={onMatch}
          />
        </>
      )}
      {potentialMatch.expectedOrder && (
        <>
          <div className={'text-lg font-semibold text-left'}>This is the Order information you selected</div>
          <HeaderBar />
          <ExpectedOrderDisplay expectedOrder={potentialMatch.expectedOrder} />
        </>
      )}
    </>
  );
};
